import { normalizeId } from "../utils";

export const coverageKeys = {
  all: ["coverage"] as const,

  detail: (projectId: string | number, documentId: string | number) =>
    [...coverageKeys.all, "detail", normalizeId(projectId), normalizeId(documentId)] as const,
};
